<template>
  <header class="header">
    <div class="header-content">
      <h1 class="title">🧠 脑筋急转弯</h1>
      <p class="subtitle">挑战你的智慧，开启思维之旅</p>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader'
}
</script>

<style src="@/styles/Header.css"></style>
